import Panel from '../components/panel/panel'

const Payment = () => <Panel />

export default Payment;